<template lang="html">
 	<div class="downloadList-container">
        <div class="breadCrumb-container">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>{{$t('message.terminal')}}</el-breadcrumb-item>
				<el-breadcrumb-item>{{$t('message.copyTerminal')}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

        <div class="body-container">
            <div class="table-container password-container verifone-panel">
                <div class="password-item">
                    <div class="item-title">
                        <span>{{$t('message.copyTerminal')}}</span>
                    </div>
                </div>

                <div class="password-item">
                    <div class="item-body">
                    	<span>{{$t('message.copyNote')}}</span>
                    </div>
                </div>

                <!-- <div class="password-item">
                    <div class="item-left">
                        <span class="required-icon">*</span><span>{{$t('message.newPassword')}}</span>
                    </div>
                    <div class="item-right">
                        <el-input v-model="newPassword" type="password"></el-input>
                    </div>
                </div> -->

                <div class="password-item">
                    <div class="item-left">
                        <span class="required-icon">*</span><span>{{$t('message.sn')}}</span>
                    </div>
                    <div class="item-right">
                        <el-input v-model="sn" type="text"></el-input>
                    </div>
                </div>

                <div class="submit-container">
                    <el-button class="verifone-btn" type="primary" plain icon="el-icon-back" @click="callBack">{{$t('message.back')}}</el-button>
                    <el-button class="verifone-btn" type="primary" icon="el-icon-document" @click="submitCopy">{{$t('message.submit')}}</el-button>
                </div>
        	</div>
        </div>

 	</div>
</template>

<script>
export default {
	data() {
		return {
            sn: '',
			sourceSn: '',
            submitSuccess: this.$t('message.submitSuccess'),
            inputCheck: this.$t('message.inputCheck')
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		init() {
			this.sourceSn = this.$route.params.sn;
		},
		handleClick(row) {
            console.log(row);
        },
        handleDetail(row) {
            let id = row.taskId;

            if(row.taskType == 0) {
                this.queryTaskDetail(0, id);
            }else if(row.taskType == 1) {
                this.queryTaskDetail(1, id);
            }else if(row.taskType == 2) {
                this.queryTaskDetail(2, id);
            }
        },
        handleStopTask(row) {
            this.cancelId = row.taskId;
            this.cancelDialogVisible = true;
        },
        callBack() {
            this.$router.replace('/terminalList');
        },
        submitCopy() {
            let obj = {
                sourceSn: this.sourceSn,
                destSn: this.sn
            };

            if(!this.sn && this.sn == '') {
                this.$message({
                    type: "error",
                    message: this.inputCheck,
                    duration:'3000',
                });

                return;
            }

            this.$axios({
                method: 'post',
                url: '/marketplace/terminal/copy',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    this.$message({
                        type: "success",
                        message: this.submitSuccess,
                        duration:'3000',
                    });

                    this.$router.replace('/terminalList');

                }
            }).catch((err) => {
                console.log(err);
            });
        }
	}

}
</script>

<style lang="css" scoped="scoped">
.table-container {
	margin-top: 60px;
    padding: 12vh 10vw;
}
.password-container {
	/* display: flex;
	display: -webkit-display;
	flex-direction: column;
	justify-content: center; */
    height: 70vh;
}
.password-item {
    display: flex;
    display: -webkit-display;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    color: #666;
	/* width: 300px; */
}
.item-title, .item-body {
	width: 260px;
}
.item-title {
	font-weight: 600;
	font-weight: 19px;
}
.item-body {
	letter-spacing: 0.5px;
}
.item-left {
    text-align: right;
}
.item-right {
    padding-left: 15px;
}
.required-icon {
    color: red;
    font-size: 20px;
}
.submit-container {
    margin-top: 20vh;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Copy.vue